import { BrandID } from "@/types/common/course"

export type ProfitLossInfoBrand = {
  BRAND_ID: number
  PROFIT_LOSS_INFO: ProfitLossInfo
}

export type ProfitLossInfo = {
  VALUATION_AMOUNT: number
  PROFIT_LOSS_AMOUNT: number
  PROFIT_LOSS_RATE: string
}

export type CourseWithProfitLoss = {
  id: BrandID
  icon: string
  description: string
  name: string
  availableAmount: string
  profitLossAmount: string
  profitLossRate: string
  profitLossStyle: string
  isNew: boolean
  divider: {
    text: string
    style: string
  } | null
  hasBuy: boolean
}

export enum PriceTextColor {
  GREEN = 'green',
  RED = 'red',
  ORANGE = 'orange',
}

export type GetAllAssetsResponsePayload = {
  courseListWithProfitLoss: Array<CourseWithProfitLoss>
}
